import styled from 'styled-components';
import { devices, fontFamily, fontSize } from '../../../Styles';

interface InputContainerProps {
  gridItem: string;
}

interface InputContentContainerProps {
  error?: string;
}

export const InputContainer = styled.div<InputContainerProps>`
  margin-bottom: 20px;
  grid-area: ${({ gridItem }) => `${gridItem}`};
  .errorMsg {
    color: ${({ theme }) => theme.palette.alert100};
    margin-top: 8px;
    margin-bottom: 0px;
  }
  p {
    padding-left: 0px;
    font-family: ${fontFamily};
    font-size: ${fontSize['inputs-label-mobile']};
    @media ${devices['no-mobile']} {
      font-size: ${fontSize['inputs-label-desktop']};
    }
  }

  .labelInput {
    color: ${({ theme }) => theme.palette.grays80};
  }
`;

export const InputContentContainer = styled.div<InputContentContainerProps>`
  box-sizing: border-box;
  display: flex;
  border-bottom: ${({ error, theme }) =>
    error ? `1px solid ${theme.palette.alert100}` : `1px solid ${theme.brandTheme.brand100}`};
  align-items: center;
  justify-content: center;
  padding: 8px 0px;
  width: 100%;
  i {
    margin-right: 8px;
  }
  @media ${devices['no-mobile']} {
    justify-content: flex-start;
    i {
      margin-right: 4px;
    }
  }
`;
export const CustomInput = styled.input`
  width: 100%;
  border: 0;
  padding: 0;
  font-family: ${fontFamily};
  font-size: ${fontSize['inputs-text-mobile']};

  ::placeholder {
    color: ${({ theme }) => theme.palette.graysPlaceholder}!important;
  }
  &:focus {
    outline: none;
  }
  @media ${devices['no-mobile']} {
    font-size: ${fontSize['inputs-text-desktop']};
  }
`;
